export const COUNTRY_CODE = 'US';
export const TOTAL_LABEL = 'Total';
export const TOTAL_TYPE = 'final';
export const SUPPORTED_NETWORKS = ['amex', 'discover', 'masterCard', 'visa'];
export const MERCHANT_CAPABILITIES = ['supports3DS'];
export const REQUIRED_SHIPPING_FIELDS = ['postalAddress', 'name', 'phone', 'email'];
// The version of Apple Pay available in macOS 10.12.1 and iOS 10.1.
export const APPLE_PAY_SESSION_VERSION = 2;
export const INVALID_SHIPPING_CONTACT_ERROR_CODE = 'shippingContactInvalid';
export const APPLE_PAY_SHIPPING_FIELDS_MAP = {
  email: 'emailAddress',
  phone: 'phoneNumber',
  firstName: 'givenName',
  lastName: 'familyName',
  postalCode: 'postalCode',
  city: 'locality',
  country: 'countryCode',
  state: 'administrativeArea',
  streetName: 'addressLines',
};
